import React from 'react';
import { AppBackdropWrapper } from './AppBackdropWrapper';
import { useRequireAuth } from '../hooks/useRequireAuth';
import { LoadingSkeleton } from 'app/modules/loading-lib/component/LoadingSkeleton';

/** App-shell gate: render a loading state until authenticated, then the app shell. */
export const RequireAuth = () => {
  const { isAuthenticated, sessionHasBeenFetched } = useRequireAuth();

  if (!sessionHasBeenFetched || !isAuthenticated) {
    return <LoadingSkeleton />;
  }

  return <AppBackdropWrapper />;
};
